import { Data } from '@angular/router'

import { LayoutOptions } from '@flowx/designer/shared/types/layout.types'

export enum NavigationTabs {
  CONFIG = 'config',
  RUNTIME = 'runtime',
}

/**
 * The tab the project header shows for the route a navigation commits to. A page under the version
 * route is Config. So is a running instance, though its URL is under /runtime/: it is a resource of
 * the version being built, and the header keeps Config selected so that Runtime is a place to go,
 * not the place it is already.
 */
export function selectedNavigationTab(routeData: Data | undefined): NavigationTabs {
  return routeData?.routeKey === 'config' || routeData?.[LayoutOptions.IS_RUNNING_INSTANCE]
    ? NavigationTabs.CONFIG
    : NavigationTabs.RUNTIME
}
